import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    wrapper: `
      md:max-w-96
      flex
      h-24
      w-full
      items-center
      lg:w-96
    `,
  },
});
